// getTranslationKey.ts
export function getTranslationKey(name: string): string {
    if (!name) return '';
    
    return name
      .trim()                         // Trim first
      .toLowerCase()
      .replace(/\s*&\s*/g, '_and_')  // Replace & (with optional spaces) with _and_
      .replace(/[^a-z0-9\s_]/g, '')   // Remove other special characters but keep underscores
      .replace(/\s+/g, '_')           // Replace spaces with underscores
      .replace(/_+/g, '_')            // Replace multiple underscores with single underscore
      .trim();
  }